export default "__VITE_ASSET__DtvH0y4R__"